"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widget = void 0;
var tslib_1 = require("tslib");
var package_json_1 = tslib_1.__importDefault(require("../../package.json"));
var config_1 = require("../config");
var eventListener_1 = require("../eventListener");
var utils_1 = require("../utils");
exports.widget = (function () {
    var host = process.env.API_BASE_URL;
    var frameId;
    var isHidden = false;
    var _selector;
    var initialized = false;
    var widgetLoaded = false;
    var currentLocation = "";
    var context = {};
    var _language = "en";
    var _isFileUploadAllowed = false;
    var frames = {};
    var _text = {};
    var subscriptions = [];
    var _timezone = undefined;
    var _customerData = {};
    function watchUrlChange() {
        setInterval(function () {
            if (window.location.href === currentLocation)
                return;
            var payload = { location: (0, utils_1.formatLocation)() };
            currentLocation = window.location.href;
            (0, utils_1.broadcastMessage)({ frames: frames, frameId: frameId, type: "url.changed", payload: payload });
        }, 1000);
    }
    function showWidget() {
        Object.values(frames).forEach(function (frame) { return frame.style.setProperty("display", "block"); });
        isHidden = false;
    }
    function hideWidget() {
        Object.values(frames).forEach(function (frame) { return frame.style.setProperty("display", "none"); });
        isHidden = true;
    }
    function setup(_a) {
        return tslib_1.__awaiter(this, arguments, void 0, function (_b) {
            var result, jsonResult_1, jsonResult, error_1, err;
            var _c;
            var apiKey = _b.apiKey, language = _b.language, customerData = _b.customerData;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (initialized) {
                            console.error("SDK is already initialized");
                            return [2, false];
                        }
                        initialized = true;
                        if (language && language.length !== 2) {
                            console.error("Language is invalid. Must be ISO 639-1");
                            return [2, false];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 7]);
                        return [4, fetch("".concat(host, "/sdk/v1/widget/init?key=").concat(apiKey), {
                                headers: { "x-api-key": apiKey },
                            })];
                    case 2:
                        result = _d.sent();
                        if (!(result.status === 403)) return [3, 4];
                        return [4, result.json()];
                    case 3:
                        jsonResult_1 = _d.sent();
                        throw new Error(jsonResult_1 === null || jsonResult_1 === void 0 ? void 0 : jsonResult_1.message);
                    case 4:
                        if (result.status !== 200)
                            throw new Error("API key is not valid, Could not init widget sdk");
                        return [4, result.json()];
                    case 5:
                        jsonResult = _d.sent();
                        if (!jsonResult)
                            throw new Error("Widget not defined");
                        if ((_c = jsonResult === null || jsonResult === void 0 ? void 0 : jsonResult.advanced) === null || _c === void 0 ? void 0 : _c.isHidden)
                            return [2];
                        exports.widget.config = jsonResult;
                        _customerData = customerData;
                        _timezone = jsonResult.timezone;
                        _language = language || jsonResult.defaultLanguage;
                        _isFileUploadAllowed = jsonResult.permissions.isUploadEnabled;
                        return [3, 7];
                    case 6:
                        error_1 = _d.sent();
                        err = error_1;
                        initialized = false;
                        console.error(err.message);
                        return [2, false];
                    case 7: return [4, (0, utils_1.waitUntilDocumentIsReady)()];
                    case 8:
                        _d.sent();
                        return [2, true];
                }
            });
        });
    }
    return {
        config: {},
        getVersion: function () { return package_json_1.default.version; },
        init: function (_a) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var setupSucceeded, settings;
            var apiKey = _a.apiKey, language = _a.language, sessionId = _a.sessionId, timezone = _a.timezone, _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.hide, hide = _c === void 0 ? false : _c, _d = _a.config, config = _d === void 0 ? {} : _d, _e = _a.text, text = _e === void 0 ? {} : _e, customerData = _a.customerData, useNewDomain = _a.useNewDomain, theme = _a.theme, props = tslib_1.__rest(_a, ["apiKey", "language", "sessionId", "timezone", "open", "hide", "config", "text", "customerData", "useNewDomain", "theme"]);
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4, setup({ apiKey: apiKey, language: language, customerData: customerData })];
                    case 1:
                        setupSucceeded = _f.sent();
                        if (!setupSucceeded)
                            return [2];
                        settings = exports.widget.config;
                        _text = text;
                        frameId = apiKey;
                        context = props.context || {};
                        frames.main = (0, utils_1.createIframe)(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, config_1.frameConfig.widget), (useNewDomain === true ? { src: "https://widget.oniroco.tech" } : {})), { selector: "body", hidden: hide }));
                        (0, utils_1.setFrameVisibility)({ frame: frames.main, isVisible: false });
                        (0, eventListener_1.addMessageListener)({ frames: frames, subscriptions: subscriptions });
                        if (timezone) {
                            _timezone = timezone;
                            settings.timezone = timezone;
                        }
                        _f.label = 2;
                    case 2: return [4, (0, utils_1.wait)(500)];
                    case 3:
                        _f.sent();
                        (0, utils_1.broadcastMessage)({
                            frames: frames,
                            frameId: frameId,
                            type: "widget.init",
                            payload: {
                                size: (0, utils_1.formatWindowSize)(),
                                context: props.context,
                                language: _language,
                                type: "widget",
                                customerData: customerData,
                                sessionId: sessionId,
                                settings: settings,
                                config: config,
                                apiKey: apiKey,
                                theme: theme,
                                text: text,
                                open: open,
                            },
                        });
                        _f.label = 4;
                    case 4:
                        if (!widgetLoaded) return [3, 2];
                        _f.label = 5;
                    case 5:
                        window.addEventListener("beforeunload", function () { return (0, utils_1.broadcastMessage)({ frames: frames, frameId: frameId, type: "widget.closed" }); });
                        window.addEventListener("resize", function () {
                            (0, utils_1.broadcastMessage)({
                                frames: frames,
                                frameId: frameId,
                                type: "parent.resized",
                                payload: { size: (0, utils_1.formatWindowSize)() },
                            });
                        });
                        return [4, (0, utils_1.wait)(600)];
                    case 6:
                        _f.sent();
                        watchUrlChange();
                        return [2];
                }
            });
        }); },
        embed: function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
            var setupSucceeded, settings;
            var apiKey = _b.apiKey, selector = _b.selector, sessionId = _b.sessionId, language = _b.language, theme = _b.theme, timezone = _b.timezone, customerData = _b.customerData, _c = _b.text, text = _c === void 0 ? {} : _c, context = _b.context, useNewDomain = _b.useNewDomain;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!selector)
                            return [2, console.error("Selector is required")];
                        if (!document.querySelector(selector))
                            return [2, console.error("Selector is not found in your DOM")];
                        return [4, setup({ apiKey: apiKey, language: language, customerData: customerData })];
                    case 1:
                        setupSucceeded = _d.sent();
                        if (!setupSucceeded)
                            return [2];
                        settings = exports.widget.config;
                        _text = text;
                        _selector = selector;
                        frames.main = (0, utils_1.createIframe)(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, config_1.frameConfig.embed), (useNewDomain === true ? { src: "https://widget.oniroco.tech" } : {})), { selector: selector }));
                        (0, eventListener_1.addEmbedMessageListener)({ frames: frames, subscriptions: subscriptions });
                        (0, utils_1.setFrameVisibility)({ frame: frames.main, isVisible: false });
                        if (timezone) {
                            _timezone = timezone;
                            settings.timezone = timezone;
                        }
                        _d.label = 2;
                    case 2: return [4, (0, utils_1.wait)(500)];
                    case 3:
                        _d.sent();
                        (0, utils_1.broadcastMessage)({
                            frames: frames,
                            frameId: frameId,
                            type: "widget.init",
                            payload: {
                                size: (0, utils_1.formatWindowSize)(),
                                language: _language,
                                type: "embed",
                                customerData: customerData,
                                text: _text,
                                open: true,
                                sessionId: sessionId,
                                settings: settings,
                                context: context,
                                apiKey: apiKey,
                                theme: theme,
                            },
                        });
                        _d.label = 4;
                    case 4:
                        if (!widgetLoaded) return [3, 2];
                        _d.label = 5;
                    case 5:
                        window.addEventListener("beforeunload", function () { return (0, utils_1.broadcastMessage)({ frames: frames, frameId: frameId, type: "widget.closed" }); });
                        return [2];
                }
            });
        }); },
        open: function (_a) {
            var _b = _a === void 0 ? { show: true } : _a, show = _b.show;
            if (!frames.main)
                return;
            if (show)
                showWidget();
            (0, utils_1.sendMessageToFrame)({ type: "widget.opened", frameId: frameId, frame: frames.main });
        },
        close: function (_a) {
            var _b = _a === void 0 ? { hide: false } : _a, hide = _b.hide;
            if (!frames.main)
                return;
            if (hide)
                hideWidget();
            (0, utils_1.sendMessageToFrame)({ type: "widget.closed", frameId: frameId, frame: frames.main });
        },
        hide: hideWidget,
        show: showWidget,
        destroy: function () {
            Object.values(frames).forEach(function (frame) { return (0, utils_1.destroyFrames)({ frame: frame, selector: _selector }); });
            subscriptions = [];
            widgetLoaded = false;
            initialized = false;
            frames = {};
        },
        sendMessage: function (message) {
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "message.outbound",
                payload: { trigger: message },
            });
        },
        getCurrentLanguage: function () {
            return _language;
        },
        getText: function () {
            return _text;
        },
        setText: function (text) {
            _text = text;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "text.changed",
                payload: { text: _text },
            });
        },
        setLanguage: function (language) {
            if (!frames.main)
                return;
            if ((language === null || language === void 0 ? void 0 : language.length) !== 2) {
                console.error("Language is invalid. Must be ISO 639-1");
                return;
            }
            _language = language;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                payload: { language: language },
                type: "language.changed",
            });
        },
        initWidget: function () {
            widgetLoaded = true;
        },
        isWidgetLoaded: function () {
            return widgetLoaded;
        },
        isHidden: function () {
            return isHidden;
        },
        getTimezone: function () {
            return _timezone;
        },
        setTimezone: function (timezone) {
            _timezone = timezone;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                payload: { timezone: timezone },
                type: "timezone.changed",
            });
        },
        on: function (event, callback) {
            var id = Date.now().toString(16);
            subscriptions.push({ id: id, event: event, callback: callback });
            return id;
        },
        getSubscriptions: function () {
            return subscriptions;
        },
        off: function (id) {
            var deletedSubscriptionIndex = subscriptions.findIndex(function (subscription) { return subscription.id === id; });
            subscriptions.splice(deletedSubscriptionIndex, 1);
            return true;
        },
        disableNotifications: function () {
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "widget.config.patch",
                payload: { notificationsEnabled: false },
            });
        },
        enableNotifications: function () {
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "widget.config.patch",
                payload: { notificationsEnabled: true },
            });
        },
        getContext: function () {
            return context;
        },
        setContextField: function (_a) {
            var _b;
            var key = _a.key, value = _a.value;
            context[key] = value;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "context.patch",
                payload: (_b = {}, _b[key] = value, _b),
            });
        },
        updateContextField: function (_a) {
            var _b;
            var key = _a.key, value = _a.value;
            context[key] = value;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "context.patch",
                payload: (_b = {}, _b[key] = value, _b),
            });
        },
        getIsFileUploadAllowed: function () {
            return _isFileUploadAllowed;
        },
        setIsFileUploadAllowed: function (enabled) {
            var _a;
            var config = exports.widget.config;
            if (!((_a = config === null || config === void 0 ? void 0 : config.permissions) === null || _a === void 0 ? void 0 : _a.isUploadEnabled) && enabled) {
                console.error("File upload not enabled this project");
                return;
            }
            if (!frames.main)
                return;
            _isFileUploadAllowed = enabled;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "file_upload.enabled.changed",
                payload: { enabled: enabled },
            });
        },
        getCustomerData: function () {
            return _customerData;
        },
        getCustomer: function () {
            return _customerData;
        },
        updateCustomerData: function (data) {
            _customerData = data;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "customer_data.changed",
                payload: { customerData: data },
            });
        },
        setCustomer: function (data) {
            _customerData = data;
            if (!frames.main)
                return;
            (0, utils_1.sendMessageToFrame)({
                frameId: frameId,
                frame: frames.main,
                type: "customer_data.changed",
                payload: { customerData: data },
            });
        },
    };
})();
